import axios from 'axios';
import router from '@/router';
import store from '@/store/index';

const axiosApi = axios.create({
	baseURL: process.env.VUE_APP_BASE_API_URL,
	withCredentials: true,
	params: {}
});

axiosApi.interceptors.response.use((response) => {
	return response;
}, (error) => {
	switch (error.response.status) {
		case 401: {
			localStorage.removeItem("authenticatedUser");
			const returnUrl = router.currentRoute.fullPath;
			if (returnUrl.startsWith('/login')) {
				if (router.currentRoute.fullPath != returnUrl) {
					router.push(returnUrl);
				}
			}
			else {
				router.push(`/login?returnUrl=${returnUrl}`);
			}
			break;
		}
		case 403:
			router.push('/accessdenied');
			break;
	}

	//return Promise.reject(error);
	throw error;
});

axiosApi.interceptors.request.use(config => {
	config.headers['AuthType'] = store.state.authType != "" ? store.state.authType : "Default";
	config.headers['Authorization'] = store.state.apiAccessToken != "" ? `Bearer ${store.state.apiAccessToken}` : "Bearer admin";
	return config;
});

export default axiosApi;